import { startOfWeek, endOfWeek } from 'date-fns';
import { WithPageSize } from './WithPaging';
import { MultiSelectOption } from '../CommonTypes';
// baseAPI complexLossFilters are always included in complexLossAPI call
interface BaseComplexLossAPIFilters {
  claimNumber?: string;
  startDate: Date;
  endDate: Date;
}
interface BaseComplexLossFiltersRequest
  extends BaseComplexLossAPIFilters,
    WithPageSize {
  complexResources?: string[];
  teams?: string[];
}

interface BaseComplexLossFilters
  extends BaseComplexLossAPIFilters,
    WithPageSize {
  complexResources?: MultiSelectOption[];
  teams?: string[];
}

export type ComplexLossFilters = BaseComplexLossFilters;
export type ComplexLossFiltersRequest = BaseComplexLossFiltersRequest;
export type ComplexLossAPIFilters = BaseComplexLossAPIFilters;

export const defaultTimeZone = 'America/New_York';
export const startDate = () => startOfWeek(new Date(), { weekStartsOn: 1 });

export const endDate = () => {
  const dateCopy = new Date();
  dateCopy.setDate(dateCopy.getDate() + 3 * 7); // add 3 weeks

  return endOfWeek(dateCopy, { weekStartsOn: 1 }); // Span only a week
};

export const defaultFilters: ComplexLossFilters = {
  startDate: startDate(),
  endDate: endDate(),
  pageSize: 10,
};
